import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["disabled"];
import clsx from 'clsx';
import { tv } from 'tailwind-variants';
import { SpriteIcons } from '@/user/components/common';
import { defaultButtonStyle, getIconSize } from './buttonStyle';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FilledButton',
    props: {
        className: {},
        color: {},
        mobileSize: {},
        desktopSize: {},
        disabled: { type: Boolean, default: false },
        iconName: {},
        iconPosition: { default: 'left' },
        iconClassName: { default: '' }
    },
    setup(__props) {
        const props = __props;
        const button = tv({
            extend: defaultButtonStyle,
            variants: {
                color: {
                    blue: 'disabled:text-blue-150 border-1 border-blue-700 bg-blue-700 !text-white hover:bg-blue-800 disabled:border-blue-200 disabled:bg-blue-200',
                    gray: 'hover:bg-gray-850 border-1 border-gray-900 bg-gray-900 !text-white disabled:border-gray-200 disabled:bg-gray-200 disabled:text-gray-400',
                    white: 'border-1 border-white bg-white text-gray-900 hover:bg-gray-200 disabled:border-gray-800 disabled:bg-gray-800 disabled:text-gray-700',
                },
                mobileSize: {
                    large: 'text-body-3 px-27 gap-8 py-10',
                    medium: 'text-body-5 px-19 gap-4 py-8',
                    small: 'text-body-6 px-17 gap-4 py-7',
                },
                desktopSize: {
                    large: 'desktop:text-body-3 desktop:gap-8 desktop:px-27 desktop:py-10',
                    medium: 'desktop:text-body-5 desktop:gap-4 desktop:px-19 desktop:py-8',
                    small: 'desktop:text-body-6 desktop:gap-4 desktop:px-17 desktop:py-7',
                },
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(_unref(button)({
                    color: props.color,
                    mobileSize: props.mobileSize,
                    desktopSize: props.desktopSize,
                    class: props.className,
                })),
                disabled: props.disabled,
                type: "button"
            }, [
                (props.iconName && props.iconPosition === 'left')
                    ? (_openBlock(), _createBlock(_unref(SpriteIcons), {
                        key: 0,
                        class: _normalizeClass(_unref(clsx)(_unref(getIconSize)(props.desktopSize, props.mobileSize), 'shrink-0', props.iconClassName)),
                        name: props.iconName
                    }, null, 8, ["class", "name"]))
                    : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default"),
                (props.iconName && props.iconPosition === 'right')
                    ? (_openBlock(), _createBlock(_unref(SpriteIcons), {
                        key: 1,
                        class: _normalizeClass(_unref(clsx)(_unref(getIconSize)(props.desktopSize, props.mobileSize), 'shrink-0', props.iconClassName)),
                        name: props.iconName
                    }, null, 8, ["class", "name"]))
                    : _createCommentVNode("", true)
            ], 10, _hoisted_1));
        };
    }
});
